"use strict";

var _defineProperty = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contracts_1 = require("@archanova/contracts");

var modules_1 = require("../modules");

var constants_1 = require("./constants");
/**
 * gets sdk environment by name
 * @param name
 */


function getSdkEnvironment(name) {
  var result = null;

  switch (name) {
    case constants_1.SdkEnvironmentNames.Main:
      result = constants_1.main;
      break;

    case constants_1.SdkEnvironmentNames.Ropsten:
      result = constants_1.ropsten;
      break;

    case constants_1.SdkEnvironmentNames.Rinkeby:
      result = constants_1.rinkeby;
      break;

    case constants_1.SdkEnvironmentNames.Kovan:
      result = constants_1.kovan;
      break;

    case constants_1.SdkEnvironmentNames.Sokol:
      result = constants_1.sokol;
      break;

    case constants_1.SdkEnvironmentNames.Xdai:
      result = constants_1.xdai;
      break;
  }

  return result;
}

exports.getSdkEnvironment = getSdkEnvironment;
/**
 * creates local sdk environment
 * @param options
 */

function createLocalSdkEnvironment() {
  var _contractAddresses;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new modules_1.Environment({
    apiOptions: {
      host: options.host || 'localhost',
      port: options.port || 8880,
      ssl: false,
      reconnectTimeout: 3000
    },
    ensOptions: {
      supportedRootNames: ['archanova.local']
    },
    ethOptions: {
      networkId: '65280',
      gasPrice: '0x77359400',
      contractAddresses: (_contractAddresses = {}, _defineProperty(_contractAddresses, contracts_1.ContractNames.AccountProvider, '0xf254E687aD631A681cC895Dbdca37230D4a6f06C'), _defineProperty(_contractAddresses, contracts_1.ContractNames.AccountProxy, '0x12939a4d566e460B7024d38b0A54535c8B282484'), _defineProperty(_contractAddresses, contracts_1.ContractNames.AccountFriendRecovery, '0x63636CABbabaDD86D2675110cD469e77Bc87B36A'), _defineProperty(_contractAddresses, contracts_1.ContractNames.ENSRegistry, '0xC5dFc16D722a4fa6afA59d94439c74537A4Ee70E'), _defineProperty(_contractAddresses, contracts_1.ContractNames.VirtualPaymentManager, '0x5E2355b6522F29D3f0096cA9F4343DB23c243586'), _contractAddresses)
    },
    apiWebSocketConstructor: null,
    storageOptions: {
      namespace: '@archanova:local'
    },
    storageAdapter: null
  });
}

exports.createLocalSdkEnvironment = createLocalSdkEnvironment;